import axios from 'axios';
import { env } from '~/env';

export const api = axios.create({
  baseURL: env.API_URL,
});

export const setDefaultCompanyTag = (companyTag: string): void => {
  if (!api) return;
  api.defaults.headers['companytag'] = companyTag;
};

export const setDefaultAuthToken = (token: string): void => {
  if (!api) return;
  api.defaults.headers['Authorization'] = `Bearer ${token}`;
};
